export default __webpack_public_path__ + "static/media/depot-icon.eb6e0dba.svg";